import React from "react";

export default function SQL_EXEC() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_EXEC</h1>
      <p>This is the SQL_EXEC component generated from the SQL JSON.</p>
    </div>
  );
}
